import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React__default, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import styles from './4f96cd135c9c0af65541d653096255ea70b55df771e09c1950627ebe73465d39.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import { getIsKeyboardUser } from '../../utils/keyboardUser/20c2377f70ef9a94b4447542a95151abfb742a2428688e09defd93848a4c3b29.cfe-internal.js';
import useEventListener from '../../hooks/useEventListener/d298373edbbbe27e03edc667e68a196078d5abecbf27f9b61af0b7bc7dd7b6a0.cfe-internal.js';
import Popper from '../../utils/Popper/53f589867426c0fe9404d76ffe1e6e0db92964f6396b0b62988d89a525e5a08b.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import { TOOLTIP_POPPER_OFFSET } from '../../utils/f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';

var _excluded = ["content", "unstable_contentKey", "placement", "children", "disabled", "delayMs", "zIndex", "className", "portalTarget", "isArrowRemoved", "style", "id", "lightTheme", "show", "onShowChange", "aria-hidden"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var Tooltip = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _children$ref;
  var content = _ref.content,
    contentKey = _ref.unstable_contentKey,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    children = _ref.children,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$delayMs = _ref.delayMs,
    delayMs = _ref$delayMs === void 0 ? 0 : _ref$delayMs,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 1000 : _ref$zIndex,
    className = _ref.className,
    portalTarget = _ref.portalTarget,
    isArrowRemoved = _ref.isArrowRemoved,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    id = _ref.id,
    _ref$lightTheme = _ref.lightTheme,
    lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme,
    externalShow = _ref.show,
    onShowChange = _ref.onShowChange,
    ariaHidden = _ref['aria-hidden'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var componentIsControlled = externalShow !== undefined;
  var _useControllableState = useControllableState(externalShow, onShowChange, externalShow),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    show = _useControllableState2[0],
    setShow = _useControllableState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInDOM = _useState2[0],
    setIsInDOM = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isVisible = _useState4[0],
    setIsVisible = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMouseHoveringComponent = _useState6[0],
    setIsMouseHoveringComponent = _useState6[1];
  var anchorRef = useRef(null);
  var flyoutRef = useRef(null);
  var flyoutOffsetBackplateRef = useRef(null);
  var timer = useRef();
  var flyoutContainerId = useId(id);
  var getIsAnchorKeyboardFocused = function getIsAnchorKeyboardFocused() {
    return document.activeElement === anchorRef.current && getIsKeyboardUser();
  };
  var triggerShowTooltip = function triggerShowTooltip() {
    var showTooltip = function showTooltip() {
      setIsInDOM(true); // Renders the flyout before the deley so that screen readers can read out the tooltip content
      clearTimeout(timer.current);
      timer.current = _setTimeout(function () {
        return setIsVisible(true);
      }, delayMs);
    };
    if (!disabled) {
      if (!show) {
        setShow(true);
        if (componentIsControlled) {
          return;
        }
      }
      showTooltip();
    }
  };
  var triggerHideTooltip = function triggerHideTooltip() {
    var hideTooltip = function hideTooltip() {
      clearTimeout(timer.current);
      setIsVisible(false);
      setIsInDOM(false);
    };
    if (show) {
      setShow(false);
      if (componentIsControlled) {
        return;
      }
    }
    hideTooltip();
  };
  useEffect(function () {
    if (externalShow) {
      triggerShowTooltip();
    } else {
      triggerHideTooltip();
    }
  }, [externalShow]);
  var handleMouseEnter = function handleMouseEnter() {
    triggerShowTooltip();
    setIsMouseHoveringComponent(true);
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    var isMouseEnteringAnchorOrTooltip = event.relatedTarget === anchorRef.current || event.relatedTarget === flyoutRef.current || event.relatedTarget === flyoutOffsetBackplateRef.current;

    /*
     * Prevents the tooltip from hiding when at least one of the following conditions are met:
     * A keyboard user exists and the anchor element is focused, but that same user is using a mouse to enter and leave the flyout or anchor, or
     * A user is moving the mouse between the anchor and the flyout
     */
    if (!isMouseEnteringAnchorOrTooltip) {
      setIsMouseHoveringComponent(false);
      if (!getIsAnchorKeyboardFocused()) {
        triggerHideTooltip();
      }
    }
  };
  var handleFocus = function handleFocus() {
    // Prevents the tooltip from showing for mouse users when the tooltip's anchor element is programmatically focused
    if (getIsKeyboardUser()) {
      triggerShowTooltip();
    }
  };
  var handleBlur = function handleBlur() {
    /*
     * Prevents the tooltip from hiding when the cursor is hovering over the anchor or flyout.
     * This allows a user to keyboard focus the anchor and then highlight/select content inside of the flyout using a mouse.
     */
    if (!isMouseHoveringComponent) {
      triggerHideTooltip();
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') {
      if (isVisible) {
        event.stopPropagation(); // prevent event from closing modals or popovers
      }
      triggerHideTooltip();
    }
  };
  useEffect(function () {
    if (disabled) {
      triggerHideTooltip();
    } else if (isMouseHoveringComponent || getIsAnchorKeyboardFocused()) {
      triggerShowTooltip();
    }
  },
  // the hide/show functionality of the tooltip based on hover and focus
  // are handled else where and thus don't need to be included here
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled]);
  useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);

  // Allows the user to press the `Escape` key to close the flyout even if the anchor element is not focused
  // handle in capture so that it runs before modal or popover event handlers
  useEventListener(document, 'keydown', handleKeyDown, {
    isCaptureEvent: true
  });
  useEventListener(anchorRef, 'mouseenter', handleMouseEnter);
  useEventListener(anchorRef, 'mouseleave', handleMouseLeave);
  useEventListener(anchorRef, 'focus', handleFocus);
  useEventListener(anchorRef, 'blur', handleBlur);

  // `isInDOM` is added as a dependency because the `flyoutRef` won't be in the DOM until `isInDOM` is `true`
  var commonFlyoutListenerOptions = {
    additionalDependencies: [isInDOM, contentKey]
  };
  useEventListener(flyoutRef, 'mouseenter', handleMouseEnter, commonFlyoutListenerOptions);
  useEventListener(flyoutRef, 'mouseleave', handleMouseLeave, commonFlyoutListenerOptions);
  var getAnchorAriaDescribedBy = function getAnchorAriaDescribedBy() {
    var _children$props;
    var anchorAriaDescribedByFromProps = children === null || children === void 0 || (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props['aria-describedby'];
    if (ariaHidden === true || ariaHidden === 'true') {
      return anchorAriaDescribedByFromProps;
    }
    var tooltipId = isInDOM ? flyoutContainerId : undefined;
    if (anchorAriaDescribedByFromProps !== undefined && tooltipId !== undefined) {
      var _context;
      return _concatInstanceProperty(_context = "".concat(anchorAriaDescribedByFromProps, " ")).call(_context, tooltipId);
    }
    if (anchorAriaDescribedByFromProps !== undefined) {
      return anchorAriaDescribedByFromProps;
    }

    // `tooltipId` might still return `undefined`
    return tooltipId;
  };
  return /*#__PURE__*/React__default.createElement(Popper, {
    open: isInDOM,
    placement: placement,
    anchor: /*#__PURE__*/React__default.cloneElement(children, {
      ref: mergeRefs(anchorRef, (_children$ref = children.ref) !== null && _children$ref !== void 0 ? _children$ref : null),
      'aria-describedby': getAnchorAriaDescribedBy()
    }),
    popper: /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
      id: flyoutContainerId,
      key: contentKey,
      ref: mergeRefs(ref, flyoutRef),
      className: classNames(className, styles.tooltip, _defineProperty(_defineProperty({}, styles.visible, isVisible), styles.lightTheme, lightTheme)),
      style: _objectSpread({
        zIndex: zIndex
      }, style),
      role: "tooltip",
      "aria-hidden": ariaHidden
    }), content, /*#__PURE__*/React__default.createElement("div", {
      "aria-hidden": true,
      className: styles.offsetBackplate,
      ref: flyoutOffsetBackplateRef
    })),
    modifiers: [{
      name: 'offset',
      options: {
        offset: TOOLTIP_POPPER_OFFSET
      }
    }],
    arrow: isArrowRemoved ? undefined : /*#__PURE__*/React__default.createElement("div", {
      className: styles.arrow
    }, /*#__PURE__*/React__default.createElement("div", null)),
    portalTarget: portalTarget
  });
});
var Tooltip$1 = Tooltip;

export { Tooltip$1 as default };
